import { defineStore } from 'pinia'

export const useShowDialogStore = defineStore('showDialog', {
  state: () => ({
    showLockDialog: false
  }),
  actions: {}
})
